class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.updateFreeShippingProgress();
    this.open();
  }

  updateFreeShippingProgress() {
    const progress = this.querySelector('[data-pxm-free-shipping-progress]');
    if (!progress || !window.routes?.cart_url) return;

    fetch(`${window.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
        return response.json();
      })
      .then((cart) => {
        if (!cart.item_count || this.querySelector('[data-pxm-cart-pickup]')) {
          progress.hidden = true;
          return;
        }

        const threshold = Number(progress.dataset.threshold) || 9000;
        const total = Number(cart.total_price) || 0;
        const remaining = Math.max(threshold - total, 0);
        const percentage = Math.min(Math.max((total / threshold) * 100, 0), 100);
        const currency = cart.currency || progress.dataset.currency || 'EUR';
        const locale = document.documentElement.lang || 'fr-FR';
        const formattedRemaining = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        }).format(remaining / 100);
        const message = progress.querySelector('.pxm-shipping-progress__message p');
        const bar = progress.querySelector('.pxm-shipping-progress__bar');
        const track = progress.querySelector('.pxm-shipping-progress__track');

        progress.hidden = false;
        progress.classList.toggle('is-complete', remaining === 0);

        if (message) {
          message.textContent = '';
          const strong = document.createElement('strong');

          if (remaining > 0) {
            message.append('Plus que ');
            strong.textContent = formattedRemaining;
            message.append(strong, ' pour profiter de la livraison offerte.');
          } else {
            strong.textContent = 'Seuil de livraison offerte atteint.';
            message.append(strong);
          }
        }

        if (bar) bar.style.setProperty('--pxm-shipping-progress', `${percentage}%`);
        if (track) track.setAttribute('aria-valuenow', Math.round(percentage));
      })
      .catch(() => {
        progress.hidden = true;
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
